import { filter, includes, isEmpty } from 'lodash';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const SHOPPING_CART_LOCAL_STORAGE_KEY = 'MENU_SHOPPING_CART';

export default create(persist((set) => ({
  shoppingCart: [],
  addItem: (data) => set((state) => {
    if (isEmpty(data)) return state;

    return {
      shoppingCart: [
        ...state.shoppingCart,
        data,
      ],
    };
  }),
  removeItem: (itemsToRemove) => set((state) => {
    if (isEmpty(itemsToRemove)) return state;

    return {
      shoppingCart: filter(state.shoppingCart, (item) => !includes(itemsToRemove, item)),
    };
  }),
}),
{
  name: SHOPPING_CART_LOCAL_STORAGE_KEY,
}));
